import { render, staticRenderFns } from "./bcxy.vue?vue&type=template&id=2cc65c3d&scoped=true&"
import script from "./bcxy.vue?vue&type=script&lang=js&"
export * from "./bcxy.vue?vue&type=script&lang=js&"
import style0 from "./bcxy.vue?vue&type=style&index=0&id=2cc65c3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc65c3d",
  null
  
)

export default component.exports